import Tag from '@preqin/ui-components/cjs/core/Tag';

import { ContactUsButton } from './ContactUsButton';

import styles from './UpsellText.module.scss';

export const TermIntelligenceText = () => {
  return (
    <div className={styles.container}>
      <div className={styles.titleWrapper}>
        <div className={styles.divider} />
        <h6>TERM INTELLIGENCE</h6>
        <div className={styles.tag}>
          <Tag label="Subscription required" type="info" />
        </div>
      </div>
      <h3 className={styles.header}>Revolutionize how you negotiate fund terms</h3>
      <p className={styles.text}>
        Term Intelligence is a groundbreaking new benchmarking solution that enables you to compare LPA terms against
        the wider market.
      </p>
      <h3 className={styles.header}>How it works?</h3>
      <p className={styles.text}>
        Information captured from LPAs is extracted, reviewed, anonymized, and aggregated by a specialized team of
        in-house attorneys to create the most up-to date, reliable and complete market benchmarks of LPA terms.
      </p>
      <h3 className={styles.header}>How to use it?</h3>
      <p className={styles.text}>
        Benchmark economic and non-economic terms across hundreds of LPAs to know if your fund terms align with market
        standards. Empower your fund term creation and negotiations with objective data on LPAs that can be filtered by
        asset class, strategy, vintage, and fund size.
      </p>
      <div className={styles.ctaWrapper}>
        <ContactUsButton label="Contact us to get access" link="https://pro.preqin.com/datasupport" />
        <ContactUsButton
          label="Learn more"
          link="https://www.preqin.com/our-products/term-intelligence"
          type="secondary"
        />
      </div>
    </div>
  );
};
